"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "premia": {
    "22501657": [{
      "hkey": "f17f4cf7",
      "slug": "premia",
      "name": "Premia",
      "primary": true,
      "skipSearch": false
    }],
    "cagiogno": [{
      "hkey": "f17f4cf7",
      "slug": "premia",
      "name": "Premia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "aa6d5dbc": [{
      "hkey": "f17f4cf7",
      "slug": "premia",
      "name": "Premia",
      "primary": true,
      "skipSearch": false
    }],
    "chioso": [{
      "hkey": "f17f4cf7",
      "slug": "premia",
      "name": "Premia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "91081f47": [{
      "hkey": "f17f4cf7",
      "slug": "premia",
      "name": "Premia",
      "primary": true,
      "skipSearch": false
    }],
    "esogo": [{
      "hkey": "f17f4cf7",
      "slug": "premia",
      "name": "Premia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;